/**
 * The stand-in cover for an article with no photograph.
 *
 * This lived as two private statics on `BlogItemComponent`, so the list had
 * covers and the article page and the "latest posts" rail beside it did not:
 * the detail screen opened on a bare title, and the sidebar showed four empty
 * grey rectangles where thumbnails should be.
 *
 * Keyed off the article's own id rather than its position in a list, so a post
 * keeps the same tint and the same icon wherever it appears. A rotation by
 * index would repaint every card whenever the ordering changed.
 */
const TINTS = ["is-ink", "is-sky", "is-amber", "is-mint"];

const ART = ["laptop", "analysis", "one-two-three", "medal"];

export function blogCoverTint(id: number | undefined | null): string {
  return TINTS[(id ?? 0) % TINTS.length];
}

export function blogCoverArt(id: number | undefined | null): string {
  return `./assets/media/landing/subjects/${ART[(id ?? 0) % ART.length]}.svg`;
}
